export const SET_OPERATORS="app/operatorsList/SET_OPERATORS"
